import { Component, inject, OnInit } from '@angular/core';
import { SettlementsService } from 'src/app/services/settlements.service';
import { faCircleNotch, faEdit } from '@fortawesome/free-solid-svg-icons';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { IconsService } from 'src/app/shared/services/icons.service';
import { Settlement } from 'src/app/models/settlement.model';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs';
import { AuthService } from 'src/app/shared/services/auth.service';
import { STORAGE_KEYS, StorageService } from 'src/app/services/storage.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ReactivateSettlementComponent } from 'src/app/components/modals/reactivate-settlement.component';

@Component({
  selector: 'app-comercial-settlements',
  template: `
    <div class="d-flex mt-0 mt-md-4">
      <div class="flex-fill">
        <h1 class="mt-2 mt-md-0">Clientes</h1>
      </div>
    </div>
    <div class="d-flex mt-4">
      <div class="me-3 d-none d-md-block">
        <ul #subnav app-nav-settlements [currentView]="currentView" class="sidebar-zazz list-unstyled"></ul>
      </div>
      <div class="flex-fill ms-auto">
        <div class="d-flex mb-3">
          <div class="flex-fill ms-2">
            <h2 class="mt-2 mt-md-0 mb-0">{{ showArchived ? 'Comerciales archivados' : 'Comercial' }}</h2>
          </div>
        </div>
        <div class="btn-group ms-3 mb-3" role="group" aria-label="Estado de clientes comerciales">
          <button type="button" class="btn btn-outline-secondary" [class.active]="!showArchived" (click)="setArchivedView(false)">Activos</button>
          <button type="button" class="btn btn-outline-secondary" [class.active]="showArchived" (click)="setArchivedView(true)">Archivados</button>
        </div>
        <div class="d-flex">
          <div class="flex-fill ms-3 me-3">
            <div class="input-group mb-3">
              <input class="form-control border-secondary border-end-0 rounded-start-3 bg-transparent" placeholder="Buscar..." [formControl]="search">
              <div class="input-group-append border border-secondary border-start-0 rounded-end-3 bg-transparent">
                <fa-icon [icon]="icons.faSearch" *ngIf="!search.value" class="input-group-text bg-transparent border-0 mt-1"></fa-icon>
                <fa-icon [icon]="icons.faTimes" *ngIf="search.value" (click)="clearSearch()" class="input-group-text bg-transparent border-0 mt-1"></fa-icon>
              </div>
            </div>
          </div>
          <div>
            <!-- select class="form-select border-secondary rounded-3 bg-transparent" (change)="selectSettlement($event)">
              <option selected [selected]="true" [value]="0">Condominio</option>
              <option *ngFor="let settlement of settlements" [value]="settlement.id" >{{settlement.name}}</option>
            </select -->
          </div>
          <div class="text-end">
            <button class="btn btn-zazz-dark ms-2 shadow-sm" *ngIf="!showArchived && authService.hasPermission('can_read_comercial')" routerLink="/condominios/create/comercio">
              <fa-icon [icon]="icons.faPlus" class="me-0 me-md-2"></fa-icon>
              <span class="d-none d-sm-none d-md-inline-block">Dar de alta cliente</span>
            </button>
          </div>
        </div>
        <div class="list-group rounded-4 rounded-md-5 mt-4">
          <div class="list-group-item table-responsive py-4">
            <table class="table">
              <thead>
                <tr>
                  <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light rounded-top-left-3 py-2 ps-3">Propiedad</th>
                  <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light py-2 d-none d-md-table-cell">Utilidad</th>
                  <th scope="col" class="text-center bg-zazz align-items-center align-middle text-light py-2">Unidades</th>
                  <th scope="col" class="text-center bg-zazz align-items-center align-middle text-light py-2">Zona</th>
                  <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light py-2">Razón social</th>
                  <th scope="col" class="text-center bg-zazz align-items-center align-middle text-light py-2">Tanque(s)</th>
                  <th scope="col" class="text-center bg-zazz align-items-center align-middle text-light py-2"></th>
                  <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light rounded-top-right-3 py-2"></th>
                </tr>
              </thead>
              <tbody>
                <tr app-tr-settlement 
                  [settlement]="settlement"
                  [profile]="profile" 
                  [permissions]="permissions"
                  [isArchived]="showArchived"
                  (enabledChange)="updateSettlementEnabled($event)"
                  *ngFor="let settlement of settlements | paginate: { itemsPerPage: payload.per_page, currentPage: p, totalItems: meta.total_entries }"
                >  
                </tr>
              </tbody>
            </table>
            <div class="text-center py-5" *ngIf="settlements.length==0&&loading">
              <fa-icon [icon]="icons.faCircleNotch" size="2x" animation="spin" class="text-secondary"></fa-icon>
              <p class="text-muted">Cargando...</p>
            </div>
            <div class="text-center py-5" *ngIf="settlements.length==0&&!loading" >
              <img src="/assets/images/empty-state.png" width="240px">
              <p class="text-muted">{{ showArchived ? 'No hay clientes comerciales archivados' : 'No se encontraron registros' }}</p>
            </div>
          </div>
          <div class="list-group-item text-center pt-3">
            <pagination-controls
              (pageChange)="p = $event"
              (pageChange)="pageChanged($event)"
              previousLabel="Prev."
              nextLabel="Sig."
              screenReaderPaginationLabel="Pagination"
              screenReaderPageLabel="page"                  
            ></pagination-controls>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: []
})
export class ComercialSettlementsComponent implements OnInit {
  loading: boolean = false;
  settlements: Settlement[] = [];
  profile: any = {};
  meta: any = {};
  permissions: any = {};
  payload: any = {
    page: 1,
    per_page: 100,
    tipo: 1,
    enabled: true
  };
  showArchived = false;

  currentView: string = 'comercial';

  search: FormControl = new FormControl();

  p: number = 1;
  storageService = inject(StorageService);
  private modal = inject(NgbModal);
  constructor(
    private store: SettlementsService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    public icons: IconsService,
    public authService: AuthService
  ) {
    this.profile = this.storageService.getItem(STORAGE_KEYS.PROFILE) ? this.storageService.getItem(STORAGE_KEYS.PROFILE).profile : null;
    this.permissions = this.storageService.getItem(STORAGE_KEYS.PERMISSIONS) ? this.storageService.getItem(STORAGE_KEYS.PERMISSIONS) : null;
    this.payload.utility_id = this.profile ? this.profile.utility_id : 0;
  }

  ngOnInit(): void {
    this.loading = true;
    this.loadSettlements(this.payload);

    this.search.valueChanges.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      switchMap((term: string) => this.store.getSettlements({
        name: term,
        tipo: this.payload.tipo,
        page: 1,
        per_page: this.payload.per_page,
        utility_id: this.payload.utility_id,
        enabled: this.payload.enabled
      }))).subscribe((results: any) => {
        this.settlements = results.data;
        this.meta = results.meta;
      });
  }

  clearSearch() {
    delete this.payload.name;
    this.search.setValue(null);
    this.loadSettlements(this.payload);
  }

  loadSettlements(payload: any) {
    this.loading = true;
    this.store.getSettlements(payload).subscribe({
      next: (settlements: any) => {
        console.log('settlements => ', settlements);
        this.settlements = settlements.data;
        this.meta = settlements.meta;
        this.loading = false;
      },
      error: (err: any) => {
        console.log(err);
        this.toastr.warning('No se encontraron registros', 'No econtrado');
        this.loading = false;
      }
    })
  }

  pageChanged(event: any) {
    this.payload.page = event;
    this.loadSettlements(this.payload);
  }

  setArchivedView(showArchived: boolean): void {
    if (this.showArchived === showArchived) {
      return;
    }

    this.showArchived = showArchived;
    this.payload.enabled = !showArchived;
    this.payload.page = 1;
    this.p = 1;
    this.search.setValue(null, { emitEvent: false });
    this.loadSettlements(this.payload);
  }

  updateSettlementEnabled(change: { settlementId: number; enabled: boolean }): void {
    if (!this.authService.hasPermission('can_edit_settlements')) return;
    if (change.enabled) {
      const ref = this.modal.open(ReactivateSettlementComponent, {
        centered: true, backdrop: 'static', keyboard: false, ariaLabelledBy: 'reactivate-settlement-title',
        beforeDismiss: () => !ref.componentInstance.saving
      });
      ref.componentInstance.settlementId = change.settlementId;
      ref.result.then(() => {
        this.toastr.success('El cliente comercial fue reactivado.', 'Éxito');
        this.loadSettlements(this.payload);
      }, () => {});
      return;
    }
    const action = change.enabled ? 'reactivar' : 'archivar';
    const detail = change.enabled
      ? 'Volverá a aparecer en la lista de clientes comerciales activos.'
      : 'Dejará de aparecer en la lista de clientes comerciales activos.';
    if (!confirm(`¿Deseas ${action} este cliente comercial? ${detail}`)) {
      return;
    }

    this.store.updateSettlementEnabled(change.settlementId, change.enabled).subscribe({
      next: () => {
        this.toastr.success(
          change.enabled ? 'El cliente comercial fue reactivado.' : 'El cliente comercial fue archivado.',
          'Éxito'
        );
        this.loadSettlements(this.payload);
      },
      error: () => this.toastr.error(`No fue posible ${action} el cliente comercial.`, 'Error')
    });
  }

}
